import { ReactNode } from "react";
import { useSelector } from "react-redux";

import NoAuthPage from "./NoAuthPage";

import { offersState } from "state/offers-slice";

type Props = {
  children?: ReactNode;
};

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const RequireContent: React.FC<Props> = ({ children }) => {
  const offers = useSelector(offersState);

  if (!offers.offersList.length) {
    return <NoAuthPage />;
  }

  return children;
};

export default RequireContent;
